import styled from 'styled-components';

export const StyledDataWrapperContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 5px;
`;
